import React, { useState, useEffect } from 'react';
import { Folha } from '../../componentes/folha/folha';
import { Button, Row, Col, Typography, Input, Modal, message, Form, Table } from 'antd';
import { useAxios } from '../../hooks';
import { InputDinheiro } from '../../componentes/Numeros/input-dinheiro';
import { SearchOutlined, PlusOutlined, DeleteOutlined } from '@ant-design/icons';

const { confirm } = Modal;

const { Paragraph } = Typography;
const GerenciarServico = () => {

    const [inputServicoValue, setInputServicoValue] = useState("");
    const [inputValorServicoValue, setInputValorServicoValue] = useState("")
    const [modalNovoServico, setModalNovoServico] = useState(false);
    const { getApiEmitirNotas } = useAxios();
    const [form] = Form.useForm();
    const [dataSource, setDataSource] = useState([]);
    const [inputTermoBusca, setInputTermoBusca] = useState("");
    const [arraySelectedRows, setArraySelectedRows] = useState([]);
    /* const [columns,setColumns] = useState([]); */

    /*     var dataSource = [
            {
              key: '1',
              descricao: 'Mike',
              valor: 32
            },
            {
              key: '2',
              descricao: 'John',
              valor: 10
            },
          ]; */

    const columns = [
        /* {
            title: '#',
            dataIndex: 'id',
            key: 'id'
        }, */
        {
            title: 'descricao',
            dataIndex: 'descricao',
            key: 'descricao'
        },
        {
            title: 'valor',
            dataIndex: 'valor',
            key: 'valor'
        }
    ]

    useEffect(() => {
        carregarServicos();
    }, [])

    const carregarServicos = async () => {
        const api = await getApiEmitirNotas();
        const result = await api.get('/servicos/filtro?termo=' + inputTermoBusca);
        setDataSource(result.data);
        // console.log(dataSource);


    }

    /* const handleSubmit = (event) => {
        event.preventDefault();
        alert(inputServicoValue)

    } */

    const salvarNovoServico = async (event) => {
        /* alert("aqui"+inputServicoValue); */

        const api = await getApiEmitirNotas();
        const result = await api.post('/servicos', { descricao: inputServicoValue, valor: inputValorServicoValue });
        try {
            if (result.data.id) {
                setModalNovoServico(false);
                message.info('Serviço salvo com sucesso!');
            }
        } catch (error) {
            message.info('Desculpe, não foi possível salvar!');
            console.log(error);
        }

        carregarServicos();
    }

    const handleChange = (event) => {
        setInputServicoValue(event.target.value);
    }

    const handleChangeValor = (valor) => {

        try {
            setInputValorServicoValue(valor);
        } catch (e) {
            console.log(e);
        }
    }

    const openModalNovoServico = () => {
        setModalNovoServico(true);
    }

    const handleChangeTermoBusca = (e) => {
        setInputTermoBusca(e.target.value);
    }

    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            /* console.log("selectedRowKeys", selectedRowKeys);
            console.log("selectedRows", selectedRows); */
            setArraySelectedRows(selectedRows);
        }

    }

    const excluirSelecionados = async () => {
        confirm({
            title: "Tem certeza que deseja excluir o(s) serviço(s)?",
            async onOk() {
                const api = await getApiEmitirNotas();
                var promise = [];
                try {
                    arraySelectedRows.forEach((row) => {
                        row.excluido = 1;
                        var result = api.post('/servicos', row);
                        promise.push(result);
                    })

                    Promise.all(promise).then((result) => {
                        var error = 0;
                        result.forEach((x) => {
                            if (!x.data) {
                                error = 1;
                            }
                        })

                        if (!error) {
                            setModalNovoServico(false);
                            message.info('Serviço excluido com sucesso!');
                        }
                        carregarServicos();
                    })
                } catch (error) {
                    message.info('Desculpe, não foi possível salvar!');
                    console.log(error);
                }
            }
        });
    }

    return (
        <>
            <Row className="linha-titulo">
                <Col>
                    <Paragraph strong={true} >Gerenciar Serviços</Paragraph>
                </Col>
            </Row>

            {/* Campos de Busca  */}
            <Row>
                <Col sm={24}>
                    <Form name="formBusca" layout="vertical" onFinish={carregarServicos}>
                        <div style={{ display: "flex" }}>
                            <Form.Item
                                name="termoBusca"
                                label="Descrição"
                            >
                                <Input type="text" onChange={handleChangeTermoBusca} value={inputTermoBusca}></Input>
                            </Form.Item>
                            <Form.Item>
                                <Button style={{ margin: "30px 10px" }} icon={<SearchOutlined />} type="primary" htmlType="submit">Buscar</Button>
                            </Form.Item>
                        </div>
                    </Form>
                </Col>
            </Row>

            {/* Botões de ação do lado direito */}
            <div style={{ display: "flex", flexDirection: "row-reverse", margin: "10px 0px" }}>
                <Row>
                    <Col>
                        <Button type="primary" icon={<PlusOutlined />} onClick={openModalNovoServico}>Novo Serviço</Button>&nbsp;
                        <Button type="dashed" icon={<DeleteOutlined />} onClick={excluirSelecionados}>Excluir</Button>
                    </Col>
                </Row>
            </div>

            <Folha>
                <Table
                    rowKey="id"
                    rowSelection={{
                        type: "checkbox",
                        ...rowSelection,
                    }}
                    dataSource={dataSource}
                    columns={columns} />
            </Folha>

            <Modal title="Novo Serviço" visible={modalNovoServico} onOk={() => form.submit()} onCancel={() => setModalNovoServico(false)}>

                <Form
                    form={form}
                    onFinish={salvarNovoServico}
                    layout="vertical"
                >
                    {/* <Form.Item style={{ borderBottom: "solid 3px #1a4f81" }} justify="space-between">
                        <strong>Novo Serviço</strong>
                    </Form.Item> */}
                    <Form.Item
                        name="descricao"
                        label="Descrição"
                        rules={[
                            {
                                required: true,
                                message: 'Por favor insira uma descrição!'
                            }
                        ]}
                    >
                        <Input
                            placeholder="Digite a descrição do novo serviço aqui..."
                            value={inputServicoValue}
                            onChange={handleChange}
                        />
                    </Form.Item>
                    <Form.Item
                        name="valor"
                        label="Valor"
                    /* rules={[
                        {
                            required: true,
                            message: 'Por favor insira um valor!'
                        }
                    ]} */
                    >
                        <Input.Group>
                            <InputDinheiro
                                placeholder="Qual valor do serviço?"
                                value={inputValorServicoValue}
                                onChangeValue={handleChangeValor}
                            />
                        </Input.Group>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
}

export { GerenciarServico };